import * as React from 'react';

import classnames from 'classnames';

import {RadioGroupContext} from './radio-group';
import styles from './radio.module.css';

type Props = {
    disabled?: boolean;
    value: string;
    children?: React.ReactNode;
    size?: number;
    shouldTopAlignInput?: boolean;
    shouldWidthFitContent?: boolean;
};

export class Radio extends React.Component<Props> {
    render() {
        return (
            <RadioGroupContext.Consumer>
                {({name, selectedValue, inline, onChange}) => {
                    const checked = this.props.value === selectedValue;
                    const radioId = `${name}-${this.props.value}`;

                    const labelStyleNames = classnames({
                        [styles.radio]: !inline,
                        [styles['radio--inline']]: inline,
                        [styles['radio--top-align']]: this.props.shouldTopAlignInput,
                        [styles['radio--width-fit-content']]: this.props.shouldWidthFitContent,
                    });

                    return (
                        <label htmlFor={radioId} className={labelStyleNames}>
                            <input
                                id={radioId}
                                name={name}
                                // @ts-expect-error
                                style={
                                    this.props.size && {
                                        width: this.props.size,
                                        height: this.props.size,
                                    }
                                }
                                type='radio'
                                role='radio'
                                checked={checked}
                                aria-checked={checked}
                                disabled={this.props.disabled}
                                onChange={(e) => this.handleChange(e, onChange)}
                            />
                            <span>{this.props.children}</span>
                        </label>
                    );
                }}
            </RadioGroupContext.Consumer>
        );
    }

    handleChange = (e: React.ChangeEvent<any>, onChange: (...args: any) => any) => {
        e.stopPropagation();

        onChange(this.props.value);
    };
}
